import { useContext } from "react";
import { AddChargebreakdownContext } from "../context/AddChargebreakdownContext";

export default function useAddChargebreakdown() {
  const context = useContext(AddChargebreakdownContext);
  if (!context) throw new Error("useAddChargebreakdownContext must be used within a AddChargebreakdownProvider.");
  return context;
}
